<template>
  <b-modal
    id="retailer_teammates_modal"
    modal-class="modal-retailer-teammates"
    centered
    size="lg"
    hide-footer
    hide-header-close
    @shown="onShown"
    @hidden="onHidden"
  >
    <button
      class="close-icon"
      @click="closeModal"
    >
      <feather-icon
        icon="XIcon"
        size="20"
      />
    </button>
    <div class="modal-teammates-body">
      <div class="modal-teammates-header mb-2">
        <span>Teammates of </span>
        <span class="retailer-name">{{ retailerName }}</span>
      </div>

      <div
        v-if="loading"
        class="text-center py-3"
      >
        <b-spinner />
      </div>

      <div v-else>
        <div
          v-if="teammates.length === 0"
          class="text-center py-3 text-muted"
        >
          No teammates found
        </div>

        <div
          v-else
          class="teammates-list-container"
        >
          <b-table
            :fields="tableFields"
            :items="teammates"
            class="teammates-table"
            responsive
            show-empty
          >
            <template #cell(name)="data">
              {{ [data.item.firstName, data.item.lastName].filter(Boolean).join(' ') || '-' }}
            </template>
            <template #cell(email)="data">
              {{ data.item.email }}
            </template>
            <template #cell(role)="data">
              <b-badge variant="light-primary">
                {{ data.item.role || 'N/A' }}
              </b-badge>
            </template>
          </b-table>
        </div>

        <div class="mt-2 text-center">
          <b-button
            variant="primary"
            @click="openInviteModal"
          >
            <feather-icon
              icon="UserPlusIcon"
              class="mr-50"
            />
            Invite Teammate
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BSpinner,
  BTable,
  BBadge,
  BButton,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { GET_RETAILER_TEAMMATES } from '@/store/modules/connections.module'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'

const { RETAILER_TEAMMATES } = constants.TRACKS.ACTIONS

export default {
  name: 'RetailerTeammatesModal',
  components: {
    BModal,
    BSpinner,
    BTable,
    BBadge,
    BButton,
    FeatherIcon,
  },
  props: {
    retailerId: {
      type: String,
      default: null,
    },
    retailerName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      teammates: [],
      tableFields: [
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'role', label: 'Role' },
      ],
    }
  },
  methods: {
    async fetchTeammates() {
      if (!this.retailerId) return

      this.loading = true
      try {
        const res = await this.$store.dispatch(GET_RETAILER_TEAMMATES, {
          retailerId: this.retailerId,
        })
        this.teammates = res?.data?.data || []
        analytics.track(RETAILER_TEAMMATES.BRAND_FETCH_TEAMMATES_SUCCESS, {
          retailerId: this.retailerId,
          teammatesCount: this.teammates.length,
        })
      } catch (err) {
        this.teammates = []
        analytics.track(RETAILER_TEAMMATES.BRAND_FETCH_TEAMMATES_FAILED, {
          retailerId: this.retailerId,
        })
      } finally {
        this.loading = false
      }
    },
    onShown() {
      analytics.track(RETAILER_TEAMMATES.BRAND_VIEWS_TEAMMATES_MODAL, {
        retailerId: this.retailerId,
        retailerName: this.retailerName,
      })
      this.fetchTeammates()
    },
    closeModal() {
      this.$bvModal.hide('retailer_teammates_modal')
    },
    onHidden() {
      analytics.track(RETAILER_TEAMMATES.BRAND_CLOSES_TEAMMATES_MODAL, {
        retailerId: this.retailerId,
      })
      this.teammates = []
      this.$emit('close')
    },
    openInviteModal() {
      analytics.track(RETAILER_TEAMMATES.BRAND_CLICKS_INVITE_TEAMMATE, {
        retailerId: this.retailerId,
      })
      this.$emit('open-invite')
    },
    refreshTeammates() {
      this.fetchTeammates()
    },
  },
}
</script>

<style lang="scss">
.modal-retailer-teammates {
  .modal-teammates-body {
    padding: 1rem;
  }

  .modal-teammates-header {
    font-weight: 600;
    font-size: 1.25rem;

    .retailer-name {
      color: #7367f0;
      font-weight: 700;
    }
  }

  .close-icon {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }

  .teammates-list-container {
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;

      &:hover {
        background: #a1a1a1;
      }
    }
  }

  .teammates-table {
    margin-top: 1rem;
    margin-bottom: 0;
  }
}
</style>
